import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  p {
    font-size: 20px;
    line-height: 26px;
    margin-left: 19px;

    @media (max-width: 1024px) {
      margin-top: 24px;
      font-size: 14px;
      line-height: 18px;
      margin-left: 16px;
    }
  }

  img {
    margin-top: 6px;
    width: 200px;
    height: 200px;

    @media (max-width: 1024px) {
      margin-left: 16px;
    }
  }
`;

const JGoldsmith = (props) => {
  const { t } = useTranslation();

  return (
    <Wrapper>
      <img src={require('assets/images/julius-goldsmith.png')} alt="" />
      <p>
        Julius is lawyer with over 20+ years of Wall St. experience in the areas of Business
        Development, New Product Development, and cross border transactions. Julius has worked in
        New York City, London, Singapore and Tokyo wherein he has extensive experience working
        across multiple disciplines including business development, finance, legal and tax related
        matters.  Julius is a member of the Dean's Advisors to the Silberman College of Business at
        Fairleigh Dickinson University (his alma mater) and also holds a CPA.  
      </p>
    </Wrapper>
  );
};

export default JGoldsmith;
